import {Image as _Image} from './Image'
import {Caption} from './Caption'

export const Image = Object.assign(_Image, {Caption})
